import React from 'react';
import PropTypes from 'prop-types';
import NextHead from 'next/head';

import { serializeJsonLd } from './serializeJsonLd';

// schema.org/VideoObject JSON-LD for a self-hosted clip (video rich results, Search Console
// video indexing). Duration is ISO 8601 (e.g. "PT15S"). uploadDate must be a full ISO 8601
// datetime with a timezone offset (e.g. "2026-09-08T00:00:00+00:00"), Google reports a
// date-only value as "missing a timezone" / "invalid datetime value".
const ScriptMarkupVideo = (props) => {
  const data = {
    '@context': 'https://schema.org/',
    '@type': 'VideoObject',
    name: props.name,
    description: props.description,
    thumbnailUrl: [props.thumbnailUrl],
    contentUrl: props.contentUrl,
    uploadDate: props.uploadDate,
    duration: props.duration,
  };

  return (
    <NextHead>
      <script
        key="ScriptMarkupVideo"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: serializeJsonLd(data) }}
      />
    </NextHead>
  );
};

ScriptMarkupVideo.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  thumbnailUrl: PropTypes.string.isRequired,
  contentUrl: PropTypes.string.isRequired,
  uploadDate: PropTypes.string.isRequired,
  duration: PropTypes.string,
};

export default ScriptMarkupVideo;
